import {
  Box,
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { FC } from "react";
import PoolDetailStyle from "./DetailsStyle";

const PoolDetailCardSkeleton: FC<any> = () => {
  const classes = PoolDetailStyle();

  return (
    <Card variant="outlined" className={classes.cardRoot}>
      <Skeleton variant="rect" animation="pulse" height={140} />
      <CardContent className={classes.cardContent}>
        <Grid container direction="column">
          <Grid item>
            <Grid container direction="row" alignItems="center">
              <Grid item xs={2}>
                <Skeleton variant="circle" className={classes.avatar} />
              </Grid>
              <Grid item xs={5}>
                <Skeleton variant="text" height={24} width={100} />
                <Skeleton variant="text" height={24} width={100} />
              </Grid>
              <Grid
                item
                xs={5}
                style={{
                  display: "contents",
                }}
              >
                <Box className={classes.socialIcons}>
                  <Skeleton variant="circle" />
                </Box>
                <Box className={classes.socialIcons}>
                  <Skeleton variant="circle" />
                </Box>
                <Box className={classes.socialIcons}>
                  <Skeleton variant="circle" />
                </Box>
                <Box className={classes.socialIcons}>
                  <Skeleton variant="circle" />
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Typography variant="body2" component="p">
              <Skeleton variant="text" />
              <Skeleton variant="text" />
            </Typography>
          </Grid>
          <Grid item>
            <Grid container direction="column">
              <Grid item>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Grid item>
                    <Typography>
                      <Skeleton variant="text" width={100} />
                    </Typography>
                  </Grid>
                  <Grid item xs={true}>
                    <Box border={"1px #ECF0F3 dashed"} marginX={"18px"}></Box>
                  </Grid>
                  <Grid item>
                    <Skeleton variant="text" width={100} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions className={classes.cardAction}>
        <Grid container direction="row">
          <Grid item lg={12}>
            <Skeleton
              variant="rect"
              height={40}
              style={{
                width: "100%",
                borderRadius: "17px",
              }}
            />
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
};

export default PoolDetailCardSkeleton;
